import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
import NotFound from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    redirect: 'ordenes',
    component: DashboardLayout,
    children: [
      {
        path: '/ordenes',
        name: 'ordenes',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Orders.vue')
      },
      {
        path: '/ordenes/edit/:orderId',
        name: 'ordenesEdit',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Orders/EditOrderForm.vue')
      },
      {
        path: '/usuarios',
        name: 'usuarios',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Users.vue')
      },
      {
        path: '/usuarios/new',
        name: 'usuariosNew',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/UserProfile/CreateProfileForm.vue')
      },
      {
        path: '/usuarios/edit/:userId',
        name: 'usuariosEdit',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/UserProfile/EditProfileForm.vue')
      },
      {
        path: '/hospitales',
        name: 'hospitales',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Hospitals.vue')
      },
      {
        path: '/hospitales/new',
        name: 'hospitalesNew',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Hopitals/CreateHospitalForm.vue')
      },
      {
        path: '/hospitales/edit/:hospitalId',
        name: 'hospitalesEdit',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Hopitals/EditHospitalForm.vue')
      },
      {
        path: '/areas',
        name: 'areas',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Areas.vue')
      },
      {
        path: '/areas/new',
        name: 'areasNew',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Areas/CreateAreaForm.vue')
      },
      {
        path: '/areas/edit/:areasId',
        name: 'areasEdit',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Areas/EditAreaForm.vue')
      },
      {
        path: '/colaborador/new',
        name: 'colaboradoresNew',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Collaborator/CreateCollaboratorForm.vue')
      },
      {
        path: '/colaborador/edit/:collaboratorId',
        name: 'colaboradoresEdit',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Collaborator/EditCollaboratorForm.vue')
      },
      {
        path: '/modelos',
        name: 'modelos',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/ClothesModels.vue')
      },
      {
        path: '/modelos/new',
        name: 'modelosNew',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Models/CreateModelsForm.vue')
      },
      {
        path: '/modelos/edit/:modelsId',
        name: 'modelosEdit',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Models/EditModelsForm.vue')
      },
      {
        path: '/marcas/new',
        name: 'marcasNew',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Brands/CreateBrandsForm.vue')
      },
      {
        path: '/marcas/edit/:brandsId',
        name: 'marcasEdit',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Brands/EditBrandsForm.vue')
      },
      {
        path: '/colores/new',
        name: 'coloresNew',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Colors/CreateColorsForm.vue')
      },
      {
        path: '/colores/edit/:colorsId',
        name: 'coloresEdit',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Colors/EditColorsForm.vue')
      },
      {
        path: '/colorbordado/new',
        name: 'threadsNew',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/ThreadsColors/CreateThreadColorsForm.vue')
      },
      {
        path: '/colorbordado/edit/:colorsId',
        name: 'threadsEdit',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/ThreadsColors/EditThreadColorsForm.vue')
      },
      {
        path: '/fuentes/new',
        name: 'fontsNew',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Fonts/CreateFontsForm.vue')
      },
      {
        path: '/fuentes/edit/:fontsId',
        name: 'fontsEdit',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Fonts/EditFontsForm.vue')
      },
      {
        path:'/pedidos/estado/',
        name:'ordenesStatus',
        component: () => import('../views/Pages/OrdersStatus.vue')

      },
      {
        path:'/pedidos/estado/todos',
        name:'todasOrdenesStatus',
        component: () => import('../views/Pages/StatusOrders/AllOrdersStatus.vue')

      },
      {
        path:'/pedidos/estado/edit/:orderId',
        name:'ordenesStatusEdit',
        component: () => import('../views/Pages/StatusOrders/EditOrderStatusForm.vue')

      }
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Login.vue')
      },
      { path: '*', component: NotFound }
    ]
  }
];

export default routes;
